const hostname = window.location.hostname;

export const isProduction =
  hostname === 'studio.dashtoon.ai' ||
  hostname === 'studio.dashtoon.com' ||
  hostname === 'dashtoon.com' ||
  hostname === 'www.dashtoon.com' ||
  hostname === 'cms.dashverse.ai'
  // hostname === 'localhost';

const isLocal = hostname === 'localhost';

export const config = {
  baseUrl: isProduction
    ? process.env.REACT_APP_API_BASE_URL
    : isLocal
    ? process.env.REACT_APP_LOCAL_API_BASE_URL
    : process.env.REACT_APP_DEV_API_BASE_URL,
};

// Per-platform release matrix (tenant × ANDROID/IOS/WEB/TIKTOK_MINIS).
// Keep OFF in production until the gateway accepts the `platforms` field on
// platform-release/withdraw — before that, a platform-scoped request is silently
// treated as all-platform by the backend. Env override wins on any host.
export const platformMatrixEnabled = process.env.REACT_APP_PLATFORM_MATRIX
  ? process.env.REACT_APP_PLATFORM_MATRIX === 'true'
  : !isProduction;